/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function() {
    // 倒计时
    function getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    let endTimeG;

    function cutDownTime() {
        let nowTime = new Date();
        let endTime = new Date(endTimeG);

        let leftTime = endTime.getTime() - nowTime.getTime();
        if (leftTime < 0) {
            setupNewCountdown();
            leftTime = 0;
        }
        let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
            leftM = Math.floor((leftTime / (1000 * 60)) % 60),
            leftS = Math.floor((leftTime / 1000) % 60);
        leftH = leftH >= 10 ? leftH : "0" + leftH;
        leftM = leftM >= 10 ? leftM : "0" + leftM;
        leftS = leftS >= 10 ? leftS : "0" + leftS;

        return {
            hour: leftH,
            minute: leftM,
            second: leftS,
        };
    }

    function setupNewCountdown() {
        const randomHour = getRandomNum(1, 9);
        const currentTime = new Date();
        endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
    }
    let intervalId;

    function getCutDownTime() {
        setupNewCountdown();
        if (intervalId) clearInterval(intervalId);
        intervalId = setInterval(function() {
            let cutDownTimeText = cutDownTime();
            $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
            $(".sp_top_cut_down .sp_left_view .sp_minute").html(
                cutDownTimeText.minute
            );
            $(".sp_top_cut_down .sp_left_view .sp_second").html(
                cutDownTimeText.second
            );
        }, 1000);
    }

    getCutDownTime();

    new WOW().init();

    new Swiper(".sp-swiper1", {
        autoplay: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        slideShadows: true,
        slidesPerView: "auto",
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
    });

    new Swiper(".sp-swiper-fade", {
        spaceBetween: 10,
        effect: "fade",
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
            delay: 2000,
        },
        speed: 2000,
    });

    new Swiper(".sp-swiper-fade1", {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 10,
        loop: true,
        on: {
            slideChange: function(e) {
                e.slides.find(".sp-text").each(function() {
                    this.style.animation = "none";
                });
                const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
                if (spText) {
                    spText.style.animation = "none";

                    spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
                }
            },
        },
    });

    new Swiper(".sp-swiper0", {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
        },
        spaceBetween: 10,
        loop: true,
    });
    function getCur() {

    }
    $(".sp-mobile .sp-option").click(function() {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
        const proBox = $(this).closest(".product-part")
        const num = proBox.find("#calcNumber").val()
        const val = $(this).data("val")
        const cur = window.product.find(item => item.option1 == val)
        let price = (Number(cur.price / 100) * Number(num)).toFixed(2);
        let compare = (Number(cur.compare_at_price / 100) * Number(num)).toFixed(2);
        $("#sp_price1").html(price);
        $("#sp_price2").html(compare);
        // const typeOptions = $(".sp-mobile .sp-type .sp-option.active").index();
        const colorOptions = $(".sp-mobile #sp-color .sp-option.active").index();
        if (colorOptions === 1) {
            $(".product-part.sp-mobile .sp-img-wrap .sp-font").show();
        } else {
            $(".product-part.sp-mobile .sp-img-wrap .sp-font").hide();
        }
        if (colorOptions === 0) {
            $(".product-part.sp-mobile .sp-img-wrap .sp-font").css("top", "505px");
            $(".product-part.sp-mobile .sp-brand").hide();
        } else if (colorOptions === 1) {
            $(".product-part.sp-mobile .sp-img-wrap .sp-font").css("top", "575px");
            $(".product-part.sp-mobile .sp-brand").show();
            $(".product-part.sp-mobile .sp-brand").html("2pc");
        } else if (colorOptions === 2) {
            $(".product-part.sp-mobile .sp-img-wrap .sp-font").css("top", "575px");
            $(".product-part.sp-mobile .sp-brand").show();
            $(".product-part.sp-mobile .sp-brand").html("3pc");
        }
        if (colorOptions == 1 && colorOptions === 1 || colorOptions == 1 && colorOptions === 2) {
            $(".product-part.sp-mobile .sp-img-wrap .sp-img-inner").css("padding-bottom", "50px");
        } else {
            $(".product-part.sp-mobile .sp-img-wrap .sp-img-inner").css("padding-bottom", "0px");
        }

        $(".product-part.sp-mobile .sp-img-p")
            .eq(colorOptions)
            .addClass("active")
            .siblings()
            .removeClass("active");

    });

    $(".sp-pc .sp-option").click(function() {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");
         const proBox = $(this).closest(".product-part")
        const num = proBox.find("#calcNumber").val()
        const val = $(this).data("val")
        const cur = window.product.find(item => item.option1 == val)
        let price = (Number(cur.price / 100) * Number(num)).toFixed(2);
        let compare = (Number(cur.compare_at_price / 100) * Number(num)).toFixed(2);
        $("#sp_price3").html(price);
        $("#sp_price4").html(compare);
        const typeOptions = $(".sp-pc .sp-type .sp-option.active").index();
        const colorOptions = $(".sp-pc .sp-color .sp-option.active").index();
        if (typeOptions === 1) {
            $(".product-part.sp-pc .sp-img-wrap .sp-font").show();
        } else {
            $(".product-part.sp-pc .sp-img-wrap .sp-font").hide();
        }
        if (colorOptions === 0) {
            $(".product-part.sp-pc .sp-img-wrap .sp-font").css("top", "360px");
            $(".product-part.sp-pc .sp-brand").hide();
        } else if (colorOptions === 1) {
            $(".product-part.sp-pc .sp-img-wrap .sp-font").css("top", "412px");
            $(".product-part.sp-pc .sp-brand").show();
            $(".product-part.sp-pc .sp-brand").html("2pc");
        } else if (colorOptions === 2) {
            $(".product-part.sp-pc .sp-img-wrap .sp-font").css("top", "412px");
            $(".product-part.sp-pc .sp-brand").show();
            $(".product-part.sp-pc .sp-brand").html("3pc");
        }
        if (typeOptions == 1 && colorOptions === 1 || typeOptions == 1 && colorOptions === 2) {
            $(".product-part.sp-pc .sp-img-wrap .sp-img-inner").css("padding-bottom", "20px");
        } else {
            $(".product-part.sp-pc .sp-img-wrap .sp-img-inner").css("padding-bottom", "0px");
        }

        $(".product-part.sp-pc .sp-img-p")
            .eq(typeOptions)
            .addClass("active")
            .siblings()
            .removeClass("active");
    });

    function mainRender() {
        $(function() {
            $("#root").css("zoom", "normal");
            if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
            } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
            }

            window.addEventListener(
                "resize",
                (function() {
                    var timer;
                    return function() {
                        if (timer) clearTimeout(timer);
                        timer = setTimeout(function() {
                            $("#root").css("zoom", "normal");
                            if (document.body.clientWidth <= 1060) {
                                let scale = document.body.clientWidth / 1080;
                                $("#root").css("zoom", scale);
                            } else {
                                const scale = document.body.clientWidth / 1920;
                                $("#root").css("zoom", scale);
                            }
                        }, 100);
                    };
                })()
            );
        });

        function lazyLoadImages() {
            // 懒加载
            const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
            const config = {
                rootMargin: "0px 0px 1300px 0px",
                threshold: 0,
            };

            const lazyLoadObserver = new IntersectionObserver(function(
                    entries,
                    observer
                ) {
                    entries.forEach(function(entry) {
                        if (entry.isIntersecting) {
                            // 当图片进入视口时
                            const image = entry.target;
                            const dataSrc = image.getAttribute("data-src");
                            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
                            lazyLoadObserver.unobserve(image); // 停止观察该图片
                        }
                    });
                },
                config);

            images.forEach(function(image) {
                lazyLoadObserver.observe(image); // 开始观察每个图片
            });
        }

        function preloadImages(imageArray) {
            // 预加载
            // 检查数组数据结构
            if (Array.isArray(imageArray[0])) {
                // 处理二维数组
                imageArray.forEach((subArray) => {
                    subArray.forEach((url) => {
                        const img = new Image();
                        img.src = url;
                    });
                });
            } else {
                // 处理一维数组
                imageArray.forEach((url) => {
                    const img = new Image();
                    img.src = url;
                });
            }
        }

        lazyLoadImages();

        // 找到所有跳转套餐的锚点链接
        var links = document.querySelectorAll('a[href^="#shopping"]');
        links.forEach(function(link) {
            link.addEventListener("click", function(event) {
                event.preventDefault(); // 阻止默认的跳转行为
                // 方式一
                const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
                const offsetTop = targetElement.offsetTop;
                let sptop = document.body.clientWidth <= 1080 ? 60 : 50;

                window.scroll({
                    top: offsetTop * $("div#root").css("zoom") -
                        sptop * $("div#root").css("zoom"),
                    behavior: "smooth", // 使用 smooth 实现平滑滚动
                });
            });
        });

        // IOS字体多了间距的处理 给节点添加 sp_system 类名
        // 判断当前用户是安卓端还是iOS端
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        var isAndroid = /android/i.test(userAgent);
        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

        if (isAndroid) {
            console.log("Android");
        } else if (isIOS) {
            console.log("iOS");
        } else if (isPC) {
            console.log("PC");
        } else {
            $(".sp_system").css("letter-spacing", "-4px");
        }
    }

    mainRender();

    let sp_price1 = window.product[0].price / 100;
    let sp_price2 = window.product[0].compare_at_price / 100;
    
    function calcTotal(price, num) {
        let result = Number(price) * Number(num);
        return result.toFixed(2);
    }
    $(".sp-mobile .sp-reduce").click(function() {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) - 1;
        if (num > 0) {
            input.value = num;
        }
        $("#sp_price1").html(calcTotal(sp_price1, input.value));
        $("#sp_price2").html(calcTotal(sp_price2, input.value));
    });
    $(".sp-mobile .sp-add").click(function() {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) + 1;
        input.value = num;
        $("#sp_price1").html(calcTotal(sp_price1, input.value));
        $("#sp_price2").html(calcTotal(sp_price2, input.value));
    });

    $(".sp-pc .sp-reduce").click(function() {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) - 1;
        if (num > 0) {
            input.value = num;
        }
        $("#sp_price3").html(calcTotal(sp_price1, input.value));
        $("#sp_price4").html(calcTotal(sp_price2, input.value));
    });
    $(".sp-pc .sp-add").click(function() {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) + 1;
        input.value = num;
        $("#sp_price3").html(calcTotal(sp_price1, input.value));
        $("#sp_price4").html(calcTotal(sp_price2, input.value));
    });
    $(".sp-btn-style").click(function() {
         const proBox = $(this).closest(".product-part")
         const val = proBox.find(".opt-group .sp-option.active").data("val")
         const cur = window.product.find(item => item.option1 == val)
         const num = proBox.find('#calcNumber').val()
         window.location.href = '/cart/' + cur.id + ':' + num
    })
    // 标题文本渐出
    const graduallyList = document.getElementsByClassName("gradually");
    for (let gradually of graduallyList) {
        const spans = gradually.querySelectorAll("span");
        const detail = gradually.querySelector(".sp-detail");
        const paragraph = gradually.querySelector(".sp-sub-title");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // 给每个 span 和 i 动画
                        spans.forEach((span, index) => {
                            span.style.animation = `swift-up-fade 0.5s ease forwards`;
                            span.style.animationDelay = `${index * 0.1}s`;

                            const i = span.querySelector("i");
                            if (i) {
                                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                                i.style.animationDelay = `${index * 0.1}s`;
                            }
                        });

                        // 段落
                        const totalDelay = spans.length * 0.1 + 0.3;
                        if (detail) {
                            detail.style.animation = `swift-up-fade2 0.5s ease forwards`;
                            detail.style.animationDelay = `${totalDelay}s`;
                        }
                        if (paragraph) {
                            paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`;
                            paragraph.style.animationDelay = `${totalDelay}s`;
                        }

                        observer.unobserve(gradually);
                    }
                });
            }, {
                threshold: 0.3,
            }
        );
        observer.observe(gradually);
    }

    // // 点击按钮
    // $(".sp-video-btn").click(function () {
    //   $(".sp-mask").css("display", "flex");
    // });

    // 菜单
    $(".sp-menu-btn").click(function(e) {
        $(".sp-menu-mask").show();
    });

    $(".sp-menu-mask").click(function(e) {
        // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
        // } else {
        $(".sp-menu-mask").hide();
        // }
    });

    // // 滚动添加底部
    // if (
    //   $(window).scrollTop() >
    //   $(".sp-part1").height() * $("div#root").css("zoom") -
    //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
    // ) {
    //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
    // } else {
    //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
    // }

    $(window).scroll(function() {

        // if (
        //   $(window).scrollTop() >
        //   $(".sp-part1").height() * $("div#root").css("zoom") -
        //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
        // ) {
        //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
        // } else {
        //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
        // }
    });

    $(function() {
        // 购物车加购动效
        $(".sp-mobile .cart-btn").click(function() {
            $(this).children("img").addClass("on");
            $(".sp-mobile .sp-cart .num").show();
            setTimeout(function() {
                $(".sp-mobile .cart-btn").children("img").removeClass("on");
            }, 500);
            $(".sp-mobile .sp-cart").addClass("on");
            setTimeout(function() {
                $(".sp-mobile .sp-cart").removeClass("on");
            }, 500);
        });

        let initNum = 0;

        $(".product-part.sp-mobile .cart-btn").click(function() {
            let spNum = $(".product-part.sp-mobile #calcNumber")[0].value;
            initNum += Number(spNum);

            // $("#calcNumber").val(1);
            const proBox = $(this).closest(".product-part")
            const val = proBox.find(".opt-group .sp-option.active").data("val")
            const cur = window.product.find(item => item.option1 == val)
            var data = {
                id: cur.id,
                quantity: proBox.find('#calcNumber').val(),
            }
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                success: function () {
                $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
                    $(".cardNum").each(function () {
                        $(this).html(result.item_count);
                    });
                    $(".cardNum").removeClass("sp-gray");
                })
                },
                dataType: 'json',
            })
            $(".cardNum").removeClass("sp-gray");
            // handleAddToCart(initNum);

            // var imgs = $(".product-part .swiper-slide-active").find("img");
            var imgs = $(".product-part.sp-mobile .sp-img-p.active");

            imgs.each(function() {
                var $img = $(this);
                var flyer = $img[0].cloneNode(true);
                flyer.classList.add("sp_clone");

                $(".product-part.sp-mobile").append(flyer);
                $(flyer).css({
                    width: $img[0].width,
                    height: $img[0].height,
                    background: "#e7e9ef",
                    position: "fixed",

                    top: $img[0].offsetTop,
                    left: $img.offset().left,
                    "z-index": 99,
                });

                let finish = $(".sp-btn-style2.sp-mobile .sp-cart");

                $(flyer).animate({
                        top: $(".sp-btn-style2")[0].offsetTop,
                        left: $(".sp-btn-style2 .sp-area2")[0].offsetLeft + 120,
                        width: 50,
                        height: 50,
                        opacity: 0.4,
                    },
                    500,
                    "linear",
                    function() {
                        $(this).animate({
                                width: 0,
                                height: 0,
                                opacity: 0,
                            },
                            0,
                            function() {
                                $(this).detach();
                            }
                        );
                    }
                );
            });
        });
    });

    // PC
    $(function() {
        // 购物车加购动效
        $(".sp-pc .cart-btn").click(function() {
            $(this).children("img").addClass("on");
            $(".sp-pc .sp-header-top .sp-cart .num").show();
            setTimeout(function() {
                $(".sp-pc .cart-btn").children("img").removeClass("on");
            }, 500);
            $(".sp-pc .sp-header-top .sp-cart").addClass("on");
            setTimeout(function() {
                $(".sp-pc .sp-header-top .sp-cart").removeClass("on");
            }, 500);
        });

        let initNum = 0;
        $(".product-part.sp-pc .cart-btn").click(function() {
            let spNum = $(".product-part.sp-pc #calcNumber")[0].value;
            initNum += Number(spNum);

            // $("#calcNumber").val(1);
            const proBox = $(this).closest(".product-part")
            const val = proBox.find(".opt-group .sp-option.active").data("val")
            const cur = window.product.find(item => item.option1 == val)
            var data = {
                id: cur.id,
                quantity: proBox.find('#calcNumber').val(),
            }
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                success: function () {
                $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
                    $(".cardNum").each(function () {
                        $(this).html(result.item_count);
                    });
                    $(".cardNum").removeClass("sp-gray");
                })
                },
                dataType: 'json',
            })
            // $(".sp-pc .cardNum").each(function() {
            //     $(this).html(initNum);
            // });
            $(".cardNum").removeClass("sp-gray");
            // handleAddToCart(initNum);

            // var imgs = $(".product-part .swiper-slide-active").find("img");
            var imgs = $(".product-part.sp-pc .sp-img-p.active");

            imgs.each(function() {
                var $img = $(this);
                var flyer = $img[0].cloneNode(true);
                flyer.classList.add("sp_clone");

                $(".product-part.sp-pc").append(flyer);
                $(flyer).css({
                    width: $img[0].width,
                    height: $img[0].height,
                    background: "#e7e9ef",
                    position: "fixed",

                    top: $img[0].offsetTop,
                    left: $img.offset().left,
                    "z-index": 99,
                });

                let finish = $(".sp-pc .sp-cart");
                $(flyer).animate({
                        top: finish[0].offsetTop,
                        left: finish[0].offsetLeft,
                        width: 50,
                        height: 50,
                        opacity: 0.4,
                    },
                    500,
                    "linear",
                    function() {
                        $(this).animate({
                                width: 0,
                                height: 0,
                                opacity: 0,
                            },
                            0,
                            function() {
                                $(this).detach();
                            }
                        );
                    }
                );
            });
        });
    });

    // 问答
    $(".q-row").click(function() {
        $(this).parent().toggleClass("sp-show");
    });

    // 文本渐出动画
    const graduallyList2 = document.getElementsByClassName("sp-fade-box");
    for (let gradually2 of graduallyList2) {
        // 排除 .sp-like 和 .sp-area 元素，这些由点赞按钮动画单独处理
        const paragraph2 = Array.from(gradually2.querySelectorAll(".sp-ani")).filter(el => {
            return !el.classList.contains('sp-like') && !el.classList.contains('sp-area');
        });

        const observerAni = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        paragraph2.forEach((span, index) => {
                            span.style.animation = `sp-fade-in 1s ease forwards`;
                            span.style.animationDelay = `${index * 0.5 + 0.5}s`;
                        });

                        observerAni.unobserve(gradually2);
                    }
                });
            }, {
                threshold: 0.3,
            }
        );
        observerAni.observe(gradually2);
    }

    // 快速文本渐出动画 sp-ani-fast
    const graduallyListFast = document.getElementsByClassName("sp-fade-box");
    for (let graduallyFast of graduallyListFast) {
        // 排除 .sp-part5 内的 .sp-area 元素，这些由点赞按钮动画单独处理
        const paragraphFast = Array.from(graduallyFast.querySelectorAll(".sp-ani-fast")).filter(el => {
            return !el.classList.contains('sp-area');
        });

        const observerAniFast = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        paragraphFast.forEach((span, index) => {
                            span.style.animation = `sp-fade-in 0.6s ease forwards`;
                            span.style.animationDelay = `${index * 0.3 + 2}s`;
                        });

                        observerAniFast.unobserve(graduallyFast);
                    }
                });
            }, {
                threshold: 0.3,
            }
        );
        observerAniFast.observe(graduallyFast);
    }
    // 文本渐出动画
    const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
    for (let gradually3 of graduallyList3) {
        const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

        const observerAni = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        paragraph3.forEach((span, index) => {
                            span.style.animation = `sp-fade-left 1s ease forwards`;
                            span.style.animationDelay = `${index * 0.3 + 1}s`;
                        });

                        observerAni.unobserve(gradually3);
                    }
                });
            }, {
                threshold: 0.3,
            }
        );
        observerAni.observe(gradually3);
    }

    // iOS 视频自动播放处理
    function handleIOSVideoAutoplay() {
        const videos = document.querySelectorAll("video[autoplay]");
        if (videos.length === 0) return;

        const playVideos = () => {
            videos.forEach((video) => {
                if (video.paused) {
                    const playPromise = video.play();
                    if (playPromise !== undefined) {
                        playPromise.catch((error) => {
                            // 自动播放被阻止，静默处理
                            console.log("Video autoplay prevented:", error);
                        });
                    }
                }
            });
        };

        // 页面加载完成后尝试播放
        if (document.readyState === "complete") {
            playVideos();
        } else {
            window.addEventListener("load", playVideos);
        }

        // 使用 IntersectionObserver 在视频进入视口时播放
        const videoObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && entry.target.paused) {
                        const playPromise = entry.target.play();
                        if (playPromise !== undefined) {
                            playPromise.catch((error) => {
                                console.log("Video autoplay prevented:", error);
                            });
                        }
                    }
                });
            }, {
                threshold: 0.1
            }
        );

        videos.forEach((video) => {
            videoObserver.observe(video);
        });

        // 监听用户交互（触摸、点击等），在首次交互后尝试播放
        let userInteracted = false;
        const handleUserInteraction = () => {
            if (!userInteracted) {
                userInteracted = true;
                playVideos();
                // 移除监听器，只需要一次交互即可
                document.removeEventListener("touchstart", handleUserInteraction);
                document.removeEventListener("click", handleUserInteraction);
                document.removeEventListener("scroll", handleUserInteraction);
            }
        };

        document.addEventListener("touchstart", handleUserInteraction, {
            once: true,
            passive: true,
        });
        document.addEventListener("click", handleUserInteraction, {
            once: true,
            passive: true,
        });
        document.addEventListener("scroll", handleUserInteraction, {
            once: true,
            passive: true,
        });
    }

    handleIOSVideoAutoplay();

    // 点赞按钮进入视图时触发动画（循环播放）
    $(".sp-like").each(function() {
        var $like = $(this);
        var $container = $like.closest('.sp-part5');
        var $areas = $container.find('.sp-area1, .sp-area2, .sp-area3');
        var loopInterval = null;

        // 移除 sp-ani 类，不使用渐入动画，改用点击动画
        $like.removeClass('sp-ani');

        // 初始隐藏 - 添加初始化类使背景和文字也隐藏
        $like.css('opacity', '0');
        $like.addClass('sp-like-init');
        $areas.css('opacity', '0');

        // 移除小图标的 sp-ani-fast 类
        $areas.removeClass('sp-ani-fast');

        // 播放一次动画的函数
        function playAnimation() {
            // 重置状态
            $like.removeClass('liked');
            $areas.css({
                'animation': 'none',
                'opacity': '0'
            });

            // 强制重绘
            void $like[0].offsetWidth;

            // 触发动画
            $like.addClass('liked');

            // 小图标依次出现
            $areas.each(function(index) {
                var $area = $(this);
                setTimeout(function() {
                    $area.css({
                        'animation': 'sp-fade-in 0.5s ease forwards'
                    });
                }, index * 100);
            });

            // 动画完成后移除动画类
            setTimeout(function() {
                $like.removeClass('liked');
            }, 600);
        }

        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    // 延迟一点，等其他元素先开始动画
                    setTimeout(function() {
                        // 先显示元素
                        $like.css('opacity', '1');
                        $like.removeClass('sp-like-init');

                        // 播放第一次动画
                        playAnimation();

                        // 设置循环，每2秒播放一次
                        loopInterval = setInterval(playAnimation, 2000);
                        // 存储到元素上，方便点击时重置
                        $like.data('loopInterval', loopInterval);
                        $like.data('playAnimation', playAnimation);
                    }, 1500);

                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.3
        });

        observer.observe($like[0]);
    });

    // 点赞按钮点击动画
    $(".sp-like").click(function() {
        var $this = $(this);

        // 找到同容器内的三个小图标
        var $container = $this.closest('.sp-part5');
        var $areas = $container.find('.sp-area1, .sp-area2, .sp-area3');

        // 清除旧的循环计时器
        var oldInterval = $this.data('loopInterval');
        if (oldInterval) {
            clearInterval(oldInterval);
        }

        // 先移除之前的动画类，确保可以重新触发
        $this.removeClass('liked');

        // 重置小图标动画
        $areas.css({
            'animation': 'none',
            'opacity': '0'
        });

        // 使用setTimeout确保类被完全移除后再添加
        setTimeout(function() {
            // 添加点赞动画类
            $this.addClass('liked');

            // 小图标依次出现
            $areas.each(function(index) {
                var $area = $(this);
                setTimeout(function() {
                    $area.css({
                        'animation': 'sp-fade-in 0.5s ease forwards'
                    });
                }, index * 100);
            });

            // 动画完成后移除点赞按钮的动画类
            setTimeout(function() {
                $this.removeClass('liked');
            }, 600);

            // 重新设置循环计时器
            var playAnimation = $this.data('playAnimation');
            if (playAnimation) {
                var newInterval = setInterval(playAnimation, 2000);
                $this.data('loopInterval', newInterval);
            }
        }, 10);
    });
});